import { Typography } from "@mui/material";
import React from "react";

export interface PageTitleProps {
  title: string;
  fontSize?: string;
  fontWeight?: string;
  paddingTop?: number;
  paddingBottom?: number;
}

const PageTitle = ({
  title,
  paddingTop = 2,
  paddingBottom = 2,
  fontWeight = "700",
  fontSize = "26px",
}: PageTitleProps) => {
  return (
    <Typography
      sx={{
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        fontWeight: fontWeight || "700",
        fontSize: fontSize || "26px",
      }}
    >
      {title}
    </Typography>
  );
};

export default React.memo(PageTitle);
